import * as actions from './actions';
import update from 'react/lib/update';

export const initState = {
	rootActivities: [],
	activities: {},
	form: {},
	isSubmitting: false,
	isFormSaved: false,
	weekNo: null,
	percentChanged: false,
	projectNumber: null,
}

export default (state = initState, action) => {
	switch (action.type) {
		case actions.DELETE_ACTIVITY_SUCCESS:
			return update(state, {
				rootActivities: {
					[action.rootIndex]: {
						activityIds: {
							$splice: [[action.index, 1]]
						}
					}
				}
			});
		case actions.DELETE_ACTIVITY_SUCCESS_SUB:
			return update(state, {
				rootActivities: {
					[action.rootIndex]: {
						subActivities: {
							$splice: [[action.index, 1]]
						}
					}
				}
			})

		case actions.DELETE_ACTIVITY_SUCCESS_THIRD:
			return update(state, {
				rootActivities: {
					[action.rootIndex]: {
						subActivities: {
							[action.thirdIndex]: {
								activityIds: {
									$splice: [[action.index, 1]]
								}
							}
						}
					}
				}
			});
		case actions.FETCH_WEEKLY_SUCCESS:
			return update(state, {
				rootActivities: {
					$set: action.rootActivities
				},
				activities: {
					$set: action.activities
				},
				weekNo: {
					$set: action.weekNo
				},
				form: {
					$set: {}
				},
				isSubmitting: {
					$set: false
				},
				isFormSaved: {
					$set: false
				},
				currDate: {
					$set: action.date
				},
				projectNumber: {
					$set: action.projectNumber
				}
			});
		case actions.SUBMIT_PERCENT_REQUEST:
		case actions.SUBMIT_PERCENT_FAILURE:
			return update(state, {
				percentChanged: { $set: true },
				activities: {
					[action.activityId]: {
						percentComplete: {
							$set: action.percent
						}
					}
				},
				form: {
					[action.activityId]: {
						$set: action.percent
					}
				}
			});
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/App/Project/WeekOverview/reducer.js